// Single source of truth for supported languages.
// `code` is what we store/lookup with — must match the keys used in i18n.js.
// `htmlLang` is what we set on <html lang>.
// `title` is the browser tab title.

export const LANGUAGES = [
  {
    code: 'en',
    label: 'EN',
    htmlLang: 'en',
    title: 'ALLIN · The All-In Community Token',
  },
  {
    code: 'zh',
    label: '简体',
    htmlLang: 'zh-CN',
    title: 'ALLIN · 梭哈者的社区共识币',
  },
  {
    code: 'zhTW',
    label: '繁體',
    htmlLang: 'zh-TW',
    title: 'ALLIN · 梭哈者的社群共識幣',
  },
  {
    code: 'ja',
    label: '日本語',
    htmlLang: 'ja',
    title: 'ALLIN · オールイン・コミュニティトークン',
  },
  {
    code: 'ko',
    label: '한국어',
    htmlLang: 'ko',
    title: 'ALLIN · 올인 커뮤니티 토큰',
  },
  {
    code: 'vi',
    label: 'Tiếng Việt',
    htmlLang: 'vi',
    title: 'ALLIN · Token Cộng Đồng All-In',
  },
];

export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const DEFAULT_LANG = 'en';

export function findLang(code) {
  return LANGUAGES.find((l) => l.code === code) ?? LANGUAGES[0];
}
